var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApplePay = function SvgApplePay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#65C1B5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Apple_Pay_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Apple_Pay_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: -6,
    y: 28.8,
    width: 28.8,
    height: 28.8,
    rx: 1.667,
    stroke: "#000",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 40.8,
    cy: 8.4,
    r: 14.4,
    stroke: "#000",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.943 18.934c-.445.506-1.158.906-1.87.849-.09-.685.26-1.413.668-1.863.445-.52 1.225-.892 1.856-.92.074.714-.216 1.413-.654 1.934Zm.646.985c-1.032-.057-1.915.563-2.405.563-.497 0-1.247-.535-2.063-.52a3.068 3.068 0 0 0-2.59 1.512c-1.114 1.841-.29 4.567.786 6.066.527.742 1.158 1.556 1.99 1.527.786-.029 1.098-.492 2.048-.492.957 0 1.232.492 2.063.478.861-.015 1.403-.742 1.93-1.485.601-.841.846-1.662.861-1.705-.014-.014-1.662-.62-1.677-2.448-.015-1.527 1.299-2.255 1.358-2.297-.742-1.057-1.9-1.17-2.3-1.2Zm5.96-2.07v11.125h1.797v-3.803h2.486c2.272 0 3.868-1.499 3.868-3.668 0-2.17-1.566-3.654-3.808-3.654h-4.343Zm1.797 1.456h2.07c1.56 0 2.45.8 2.45 2.205 0 1.406-.89 2.212-2.457 2.212h-2.063v-4.417Zm9.634 9.755c1.129 0 2.175-.55 2.65-1.42h.038v1.334h1.662v-5.537c0-1.606-1.336-2.64-3.392-2.64-1.908 0-3.318 1.048-3.37 2.49h1.618c.134-.685.794-1.135 1.7-1.135 1.099 0 1.715.493 1.715 1.399v.614l-2.242.128c-2.086.121-3.214.942-3.214 2.37 0 1.44 1.165 2.397 2.835 2.397Zm.483-1.32c-.957 0-1.566-.443-1.566-1.12 0-.7.586-1.107 1.707-1.17l1.997-.122v.628c0 1.042-.92 1.784-2.138 1.784ZM36.55 32c1.751 0 2.575-.642 3.295-2.59L43 20.903h-1.826l-2.115 6.573h-.038l-2.115-6.573h-1.878l3.043 8.1-.163.492c-.275.835-.72 1.156-1.514 1.156-.141 0-.416-.014-.527-.028v1.334c.104.029.549.043.683.043Z",
    fill: "#fff"
  }))));
};
export default SvgApplePay;